<template>
  <div class="carousel-wrapper">
    <!-- Hero Title Section -->
    <v-row justify="center" class="mb-10 mt-8 px-4">
      <v-col cols="12" class="text-center">
        <div class="hero-pre-title">Premium Farm Selection</div>
        <h1 class="hero-main-title">
          Experience the <span class="highlight">organic</span> lifestyle<br />
          with <span class="highlight-alt">freshness</span> delivered.
        </h1>
        <p class="hero-subtitle mt-4">Discover a curated selection of plants, fruits, and premium spices.</p>
      </v-col>
    </v-row>

    <!-- Banner Grid Section -->
    <v-row justify="center" class="px-4 mb-14">
      <v-col cols="12" lg="11" xl="10">
        <v-row>
          <!-- Promo Banner -->
          <v-col cols="12" sm="6" md="4">
            <v-card flat class="premium-banner promo" height="260">
              <v-img
                src="../../assets/Images/MaskGroup2.png"
                height="100%"
                cover
                eager
                class="banner-img-zoom"
              >
                <div class="premium-banner-overlay d-flex flex-column justify-center align-center text-center pa-6">
                  <div class="promo-title mb-1" >{{ codes.description }}</div>
                  <div class="promo-sub">Use Exclusive Code</div>
                  <div class="promo-tag mt-3" v-if="codes.promoCode">{{ codes.promoCode }}</div>
                  <v-btn small outlined color="white" class="mt-4 promo-btn" @click="shopNow">Shop Now</v-btn>
                </div>
              </v-img>
            </v-card>
          </v-col>

          <!-- Plants Banner -->
          <v-col cols="12" sm="6" md="4">
            <v-card flat class="premium-banner" height="260" @click="$router.push('/products?MainCategory=Plants')">
              <v-img
                src="../../assets/Images/Mask Group 1.png"
                height="100%"
                cover
                eager
                class="banner-img-zoom"
              >
                <div class="premium-banner-overlay d-flex flex-column justify-center align-center text-center pa-8">
                  <span class="banner-micro-tag">Collection 2026</span>
                  <h3 class="banner-heading mt-1">Indoor<br />Sanctuary</h3>
                  <div class="banner-link mt-2" style="position: relative; display: inline-block;">
                    Explore Plants
                    <v-icon size="16" style="position: absolute; right: -24px; top: 50%; transform: translateY(-50%);">mdi-arrow-right</v-icon>
                  </div>
                </div>
              </v-img>
            </v-card>
          </v-col>

          <!-- Spices Banner -->
          <v-col cols="12" sm="6" md="4">
            <v-card flat class="premium-banner" height="260" @click="$router.push('/products?MainCategory=Spices')">
              <v-img
                src="../../assets/Images/Mask Group 3.png"
                height="100%"
                cover
                eager
                class="banner-img-zoom"
              >
                <div class="premium-banner-overlay d-flex flex-column justify-center align-center text-center pa-8">
                  <span class="banner-micro-tag">100% Organic</span>
                  <h3 class="banner-heading mt-1">Aromatic<br />Spices</h3>
                  <div class="banner-link mt-2" style="position: relative; display: inline-block;">
                    Shop Flavors
                    <v-icon size="16" style="position: absolute; right: -24px; top: 50%; transform: translateY(-50%);">mdi-arrow-right</v-icon>
                  </div>
                </div>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Main Carousel Section -->
    <v-row justify="center" class="px-4 mb-16">
      <v-col cols="12" lg="11" xl="10">
        <div class="carousel-container-outer">
          <v-carousel
            cycle
            hide-delimiter-background
            :show-arrows="false"
            :height="sliderHeight"
            class="professional-carousel"
            delimiter-icon="mdi-circle-small"
          >
            <v-carousel-item v-for="(slide, i) in photos" :key="i">
              <v-card flat tile :href="slide.link" class="slider-fill">
                <v-img
                  :src="mediaURLOld + slide.image"
                  :height="sliderHeight"
                  class="slider-img-main"
                  cover
                  :eager="i === 0"
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="#3EA56E" size="40"></v-progress-circular>
                    </v-row>
                  </template>
                  <v-overlay absolute opacity="0.1"></v-overlay>
                </v-img>
              </v-card>
            </v-carousel-item>
          </v-carousel>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      photos: [],
      appLoading: false,
      codes: {},
    };
  },
  computed: {
    sliderHeight() {
      let height = "400px";
      if (this.$vuetify.breakpoint.xl) height = "450px";
      if (this.$vuetify.breakpoint.lg) height = "380px";
      if (this.$vuetify.breakpoint.md) height = "300px";
      if (this.$vuetify.breakpoint.sm) height = "220px";
      if (this.$vuetify.breakpoint.xs) height = "140px";
      return height;
    },
  },
  beforeMount() {
    this.getData();
  },
  mounted() {
    this.getPromocode();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/home/slider/getlist",
        headers: { "x-auth-token": localStorage.getItem("token") },
        params: { istop: true },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.photos = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getPromocode() {
      axios({
        method: "get",
        url: "/product/valid/promocode/list",
        headers: { "x-auth-token": localStorage.getItem("token") },
        params: { page: 1, limit: 1 }
      })
        .then((response) => {
          if (response.data.data && response.data.data.length > 0) {
            this.codes = response.data.data[0];
          }
        })
        .catch((err) => console.log(err));
    },
    shopNow() {
      if (this.codes && this.codes.productId && this.codes.productId.urlname) {
        localStorage.setItem("productId", this.codes.productId._id);
        this.$router.push('/productdetailview/' + this.codes.productId.urlname);
      } else if (this.codes && this.codes.productId) {
        const pId = this.codes.productId._id || this.codes.productId;
        localStorage.setItem("productId", pId);
        this.$router.push('/productdetailview/' + pId);
      } else {
        this.$router.push('/products/PLANTS');
      }
    },
  },
};
</script>

<style scoped>
.carousel-wrapper {
  background: white;
}

/* Hero Section */
.hero-pre-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  color: #3EA56E;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 13px;
  margin-bottom: 8px;
}

.hero-main-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  font-size: 48px;
  line-height: 1.1;
  color: #1e293b;
  letter-spacing: -1.5px;
}

.hero-main-title .highlight { color: #3EA56E; }
.hero-main-title .highlight-alt { color: #64748b; }

.hero-subtitle {
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  color: #64748b;
  max-width: 600px;
  margin: 0 auto;
}

/* Premium Banners */
.premium-banner {
  border-radius: 24px !important;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;
  position: relative;
}

.premium-banner:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.1) !important;
}

.banner-img-zoom {
  transition: transform 0.6s ease;
}

.premium-banner:hover .banner-img-zoom {
  transform: scale(1.1);
}

.premium-banner-overlay {
  background: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.7));
  height: 100%;
  color: white;
}

.premium-banner.promo .premium-banner-overlay {
  background: rgba(62, 165, 110, 0.9);
}

.promo-title { font-family: 'Poppins', sans-serif; font-size: 24px; font-weight: 700; }
.promo-sub { font-size: 13px; opacity: 0.9; text-transform: uppercase; letter-spacing: 1px; }
.promo-tag { 
  background: white; 
  color: #3EA56E; 
  padding: 6px 20px; 
  border-radius: 12px; 
  font-weight: 700; 
  font-size: 16px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.banner-micro-tag { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 1.5px; opacity: 0.9; }
.banner-heading { font-family: 'Poppins', sans-serif; font-size: 26px; font-weight: 700; line-height: 1.2; }
.banner-link { font-size: 14px; font-weight: 600; text-decoration: underline; text-underline-offset: 4px; }

/* Main Carousel */
.carousel-container-outer {
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 25px 60px rgba(0,0,0,0.12);
}

.professional-carousel {
  border-radius: 24px !important;
}

.slider-img-main {
  transition: transform 0.8s ease;
}

.slider-fill {
  height: 100%;
}

/* Nav Styles */
.professional-carousel ::v-deep .v-window__prev,
.professional-carousel ::v-deep .v-window__next {
  background: rgba(255, 255, 255, 0.9) !important;
  color: #1e293b !important;
  width: 50px;
  height: 50px;
  margin: 0 24px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important;
}

.professional-carousel ::v-deep .v-window__prev:hover,
.professional-carousel ::v-deep .v-window__next:hover {
  background: #3EA56E !important;
  color: white !important;
}

.professional-carousel ::v-deep .v-carousel__controls__item .v-icon {
  opacity: 0.4;
  transform: scale(1.5);
}

.professional-carousel ::v-deep .v-carousel__controls__item.v-btn--active .v-icon {
  opacity: 1;
  color: #3EA56E !important;
}

@media (max-width: 600px) {
  .hero-main-title { font-size: 32px; }
  .hero-subtitle { font-size: 15px; }
  .premium-banner { border-radius: 16px !important; height: 220px !important; }
  .banner-heading { font-size: 20px; }
}
</style>
